import { VStack } from '@sgme/ui';
import { type ChangeEvent, useState } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';

import { ClientsTable } from '@/components/ClientSelector/ClientsTable.tsx';

type Props = {
  triggerRef: React.RefObject<HTMLButtonElement | null>;
  onClose: () => void;
  onSelectClient: (clientId: number) => void;
};

export const ClientSelectorPanel = ({ triggerRef, onClose, onSelectClient }: Props) => {
  const { formatMessage } = useIntl();

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchTermChange = (event: ChangeEvent<HTMLInputElement>) => setSearchTerm(event.target.value);

  return (
    // We stop propagation of keydown events to allow space to be inputted
    // react-boostrap bug: https://github.com/react-bootstrap/react-bootstrap/issues/3105
    <div onKeyDown={(e) => e.stopPropagation()}>
      <Overlay show target={triggerRef} rootClose onHide={onClose} placement="bottom">
        <Popover style={{ maxWidth: 'unset' }}>
          <Popover.Body>
            <div className="card" style={{ width: '48rem' }}>
              <div className="card-header gap-2 input-group">
                <VStack fullWidth>
                  <div className="alert alert-outline-warning p-2 mb-2 fw-bold d-flex align-items-center justify-content-between">
                    <FormattedMessage id="clientSelection.tileContextBanner" tagName="span" />
                  </div>
                  <input
                    className="form-control"
                    placeholder={formatMessage({ id: 'tab.menu.filter.placeholder' })}
                    value={searchTerm}
                    onChange={handleSearchTermChange}
                    data-e2e="client-search-input"
                  />
                </VStack>
              </div>

              <div className="card-body">
                <ClientsTable searchTerm={searchTerm} onSelectClient={onSelectClient} />
              </div>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
};
